import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Capacitor } from '@capacitor/core'
import { installNativeApiShim } from './lib/nativeApi'
import { registerServiceWorker } from './lib/swController'
import App from './App'
import { AuthProvider } from './contexts/AuthContext'
import { ConfirmModalProvider } from './components/ConfirmModal'
import { ThemeProvider } from './contexts/ThemeContext'
import ErrorBoundary from './components/ErrorBoundary'
import './index.css'
import './styles/home-arm.css'
import './styles/shell-otp.css'

// FIX A (native shell): install the native-only backend-URL shim BEFORE any
// other code runs — AuthContext fires get-my-player the instant the auth state
// resolves post-login, so the shim must already be wrapping window.fetch or the
// first backend call escapes unrewritten and the splash hangs. On web this is a
// strict no-op (installs nothing, window.fetch untouched).
installNativeApiShim({ isNative: Capacitor.isNativePlatform() })

// F-001-T4f: iOS-only footer polish hook. Add a `platform-ios` class to the
// document root when running on iOS so the iOS-scoped .bottom-nav CSS overrides
// (shorter footer + inward nav-icon nudges, in index.css/home-arm.css) apply
// there and NOWHERE else. Behavior-neutral (CSS hook only), gated exactly like
// statusBar.js's native gate. Top-level module scope, not a React effect, so it
// runs once and StrictMode double-invoke is irrelevant; a strict no-op on
// web/Android since the class is never added.
if (Capacitor.getPlatform() === 'ios') {
  document.documentElement.classList.add('platform-ios')
}

// Service-worker update lifecycle (F-074 — reliable, non-disruptive updates).
//
// The Netlify [[headers]] block keeps /sw.js + /index.html on a must-revalidate
// cache so a new deploy's service worker is FOUND promptly instead of being
// served stale from the CDN/HTTP cache. The apply/defer logic — install-but-wait
// a new SW, activate it only at a safe moment, and never let a purged/missing
// lazy chunk crash the scorecard mid-round — lives in ./lib/swController.js
// (which App.jsx also calls into on in-app navigation to a safe surface).
registerServiceWorker()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <ThemeProvider>
        <AuthProvider>
          <ConfirmModalProvider>
            <App />
          </ConfirmModalProvider>
        </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
)
